module.exports = __webpack_public_path__ + "img/寺岛良.08510b15.png";